import { get, post } from '@/common/request';
import { useEffect, useState } from 'react';

/**
 * @description: 获取省市区列表
 * @param {number} type 返回数据类型  1：省市区  2：省市
 * @param {boolean} visible
 * @param {string} range all全部 limit用户权限范围内的场地的城市列表
 * @return {*}
 */
function useAreaList(type: number, visible?: boolean, range = 'all') {
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    const getAreaList = async () => {
      if (range === 'limit') {
        // https://yapi.lanhanba.com/project/319/interface/api/54466
        const data = await post('/property/place/cities', {}, { needCancel: false });
        setData(data);
      } else {
        // 直接调账号中心地址接口
        // https://yapi.lanhanba.com/project/378/interface/api/35461
        const data = await get('/area/list', { type }, { needCancel: false, proxyApi: '/mirage' });
        setData(data);
      }

    };

    if (!type) {
      return;
    }

    if (visible === undefined || visible) {
      getAreaList();
    }

  }, [type, visible]);

  return data;
}

export default useAreaList;
